import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3Div from "../../../core/et3-div";
import getKhattabatSelectsStore from "../../../stores/khattabat-stores/selects-store";

const ConversationMarker = withLiteObserverAndTheme<{
  userID: number;
  isMarkedConversation: boolean;
}>((props) => {
  const { theme, userID, isMarkedConversation } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={40}
      height={80}
      color={isMarkedConversation ? colors.all.green : colors.all.dimGray}
      style={{
        cursor: "pointer"
      }}
      onClick={() => {
        return getKhattabatSelectsStore().toogleMarkConversation({
          userID
        });
      }}
    ></ET3Div>
  );
});

export default ConversationMarker;
